<ng-template #autoTranslateModalContent>
  <div class="absolute top-8 left-8">
    <div class="flex items-center gap-4">
      <nrc-icon
        class="w-12 h-12"
        [name]="'translate-circle'"
        [fillColor]="'cyan'"
      />
      <span class="text-4xl font-light tracking-wide">
        {{ modalTexts.title }}
      </span>
    </div>
  </div>

  <div class="flex flex-col justify-between w-full h-full grow">
    <form [formGroup]="autoTranslateFormGroup" #overflowParentElement class="flex flex-col my-3 space-y-4">
      <p class="font-light text-md text-[#ADADAD] pt-10">
        {{ modalTexts.description }}
      </p>

      <div class="h-[3rem]">
        <nrc-input-language-selector
          [options]="sourceLanguageCodes"
          [formControl]="autoTranslateFormGroup.controls.sourceLanguage"
          [type]="inputLanguageSelectorComponentType.LABELED"
          [overflowElement]="overflowParentElement"
          [label]="'From'"
          (languageChanged)="autoTranslateFormGroup.controls.sourceLanguage.setValue($event)"
        />
      </div>

      <div class="h-[3rem]">
        <nrc-input-language-selector
          [options]="targetLanguageCodes"
          [formControl]="autoTranslateFormGroup.controls.targetLanguage"
          [type]="inputLanguageSelectorComponentType.LABELED"
          [overflowElement]="overflowParentElement"
          [label]="'To'"
          (languageChanged)="autoTranslateFormGroup.controls.targetLanguage.setValue($event)"
        />
      </div>

      @if (fileId && autoTranslateFormGroup.controls.exportAsPdf) {
        <nrc-input-checkbox
          [formControl]="autoTranslateFormGroup.controls.exportAsPdf"
          [id]="'export-as-pdf'"
          [label]="'Generate and save translated file as PDF'"
        />
      }

      @if (modalTexts.subline) {
        <span class="text-sm text-[#ADADAD]" [innerHTML]="modalTexts.subline"></span>
      }
    </form>


    <div class="flex flex-col gap-2">
      <hr class="w-full h-[2px] mt-3 bg-[#2d2d2d] border-none">
      <div class="flex flex-row justify-between w-full mt-3 mb-1">
        <nrc-button
          [label]="'Cancel'"
          [buttonType]="buttonType.DEFAULT"
          [role]="actionRole.SECONDARY"
          [fontWeight]="'bold'"
          (clickEvent)="closeEvent.emit()"
        />

        <nrc-button
          [label]="'Translate'"
          [buttonType]="buttonType.DEFAULT"
          [role]="actionRole.PRIMARY"
          [fontWeight]="'bold'"
          [disabled]="autoTranslateFormGroup.invalid"
          (clickEvent)="handleAutoTranslateEvent()"
        />
      </div>
    </div>
  </div>
</ng-template>